module.exports = __webpack_public_path__ + "img/Sam Gittis.e4390e5e.jpg";